import type { Theme } from 'theme-ui';

export const defaultTheme: Theme = {
  fonts: {
    body: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
    heading: '"Avenir Next", sans-serif',
    monospace: 'Menlo, monospace',
  },
  colors: {
    text: '#fff',
    background: '#000',
    primary: '#33e',
    accent: '#ff7518',
  },
};
